
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";
import {
  CartItem,
  CartItemPaymentTerms,
  CartItemType,
} from "@/types/cart-item";
import PaymentSchedule from "@/views/_components/PaymentSchedule.vue";

const { State } = namespace("Root");

@Component({
  components: {
    PaymentSchedule,
  },
})
export default class WizardCartWindow extends Vue {
  @State("cart") cart!: Cart;

  @Prop({ default: false })
  hidden!: boolean;

  modal_class = "cart-window";
  observer: any;

  created() {
    // Remove the validation object if the item is deleted.
    this.cart.itemRemoved.on(this.itemRemoved);
    // Register browser back/forward event
    window.addEventListener("popstate", this.onPopState);
    // Register browser back/forward event
    window.addEventListener("resize", this.onResize);
  }

  mounted() {
    this.observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (
          m.removedNodes &&
          m.removedNodes.length > 0 &&
          m.removedNodes[0].nodeName.toLowerCase() == "table"
        )
          this.$nextTick(() => {
            this.onResize();
          });
      }
    });

    this.observer.observe(this.$refs.stickyCart, {
      attributes: false,
      childList: true,
      subtree: false,
    });

    this.onResize();
  }

  heightChanged() {
    this.onResize();
  }

  beforeDestroy() {
    this.cart.itemRemoved.off(this.itemRemoved);
    // remove the event listener
    window.removeEventListener("popstate", this.onPopState);
    // remove the event listener
    window.removeEventListener("resize", this.heightChanged);
    this.observer.disconnect();
  }

  itemRemoved(cart_item?) {
    // If we don't have items, hide the cart on mobile.
    if (this.cart.items.length == 0 && this.hidden) {
      this.hide();
    }
  }
  /**
   * Back or forward button has been clicked on browser.
   */
  onPopState() {
    // Remove no scroll, so when we return to the main window it can scroll
    this.hide();
  }

  onResize() {
    let div = this.$refs.stickyCart as any;
    if (div) {
      // It does this sometimes...
      if (div.offsetHeight == 0) {
        return;
      }
      let div_height = div.offsetHeight + 231;
      let doc_height = window.outerHeight;

      if (div_height > doc_height) {
        div.classList.add("nonsticky");
      } else {
        div.classList.remove("nonsticky");
      }
    }
  }

  /**
   * Checks if there are multiple items of the same category in the cart.
   * @param code string
   */
  hasMultiple(code: string) {
    return this.cart.countByCode(code) > 1;
  }

  isMonthly(type: CartItemPaymentTerms) {
    return type == CartItemPaymentTerms.Monthly;
  }

  //TODO
  /**
   * Apply indexing of the items of the same cpde in the cart.
   * @param code
   * @param id
   */
  getIndexOfCode(code: string, id: number) {
    return this.cart.indexOfCode(code, id);
  }

  getModelName(id: number) {
    let item = this.cart.items.find((item) => {
      return item.id == id;
    });
    if (!item) {
      return "";
    }
    if (item.model != "") {
      return item.model;
    } else {
      if (this.hasMultiple(item.code)) {
        return "(" + this.getIndexOfCode(item.code, item.id) + ")";
      } else {
        return "";
      }
    }
  }

  /**
   * Remove cart item.
   * @param id
   */
  deleteItem(id: number): void {
    this.cart.deleteItem(id);
  }

  getDeductible(item: CartItem) {
    return item.deductible_object.value >= 0 ? item.deductible_object.text : 0;
  }

  /**
   * Removes no scroll and hides the window when modal.
   */
  hide() {
    this.removeNoScroll();
    this.modal_class = "cart-window hide";
  }

  /**
   * Shows this window as modal and add's noscroll to the parent body.
   */
  show() {
    this.addNoScroll();
    this.modal_class = "cart-window show";
  }

  /**
   * Add no scroll to the main body, so we don't get main window
   * scrolling while we're shown as modal.
   */
  addNoScroll() {
    // Fixes the scrolling of the checkout progress on mobile
    let el = document.getElementsByTagName("body");
    if (el && el[0]) {
      el[0].classList.add("noscroll");
    }
  }

  /**
   * Remove the noscroll class, so the main window can scroll.
   */
  removeNoScroll() {
    // Fixes the scrolling of the checkout progress on mobile
    let el = document.getElementsByTagName("body");
    if (el && el[0]) {
      el[0].classList.remove("noscroll");
    }
  }
}
